import React from 'react';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import DatePickerComponent from '../../common/DatePicker';
import moment from 'moment';
import GenericButton from '../../common/button';

const ACTION_OPTIONS = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Registration',
    value: 'Registration',
  },
  {
    label: 'Unlock Account',
    value: 'Unlock Account',
  },
  {
    label: 'Forgot Email',
    value: 'Forgot Email',
  },
  {
    label: 'Forgot Password',
    value: 'Forgot Password',
  },
];

const USER_TYPE_OPTIONS = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Employee',
    value: 'Employee',
  },
  {
    label: 'Dependent',
    value: 'Dependent',
  },
];

const EnumerationAuditLogFilter = ({
  filters,
  setFilters,
  onSearch,
  useridOptions,
  isLoading,
}) => {
  return (
    <div className="container-offset-audit-filter">
      <div className="audit-filter-container">
        <div className="audit-filter-group">
          <div className="row-container">
            <div className="col-section category-section-container">
              <span className="filter-label">User ID</span>
              <div>
                <AutoSuggestionSelectComponent
                  options={useridOptions}
                  placeholder="User ID"
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="audit-filter-dropdown"
                  value={useridOptions.find(
                    (item) => item.value === filters.userid,
                  )}
                  onChange={(event) =>
                    setFilters((prev) => ({ ...prev, userid: event.value }))
                  }
                  isSearchable={false}
                />
              </div>
            </div>
            <div className="col-section category-section-container">
              <span className="filter-label">Action Type</span>
              <div>
                <AutoSuggestionSelectComponent
                  options={ACTION_OPTIONS}
                  placeholder="Action Type"
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="audit-filter-dropdown"
                  value={ACTION_OPTIONS.find(
                    (item) => item.value === filters.actiontype,
                  )}
                  onChange={(event) =>
                    setFilters((prev) => ({ ...prev, actiontype: event.value }))
                  }
                  isSearchable={false}
                />
              </div>
            </div>
            <div className="col-section category-section-container">
              <span className="filter-label">User Type</span>
              <div>
                <AutoSuggestionSelectComponent
                  options={USER_TYPE_OPTIONS}
                  placeholder="User Type"
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="audit-filter-dropdown"
                  value={USER_TYPE_OPTIONS.find(
                    (item) => item.value === filters.usertype,
                  )}
                  onChange={(event) =>
                    setFilters((prev) => ({ ...prev, usertype: event.value }))
                  }
                  isSearchable={false}
                />
              </div>
            </div>

            <div className="from-to-date">
              <div className="col-section category-section-container">
                <span className="filter-label">From Date</span>
                <DatePickerComponent
                  key={`from-${filters?.todate || 'empty'}-${
                    filters?.fromdate || 'empty'
                  }`}
                  value={filters?.fromdate ? new Date(filters.fromdate) : null}
                  placeholder="MM-DD-YYYY"
                  className="audit-date-picker"
                  onChange={(date) => {
                    if (!date) {
                      setFilters((prev) => ({ ...prev, fromdate: null }));
                      return;
                    }
                    const fromdate = moment(date).format('YYYY-MM-DD');
                    let todate = filters?.todate;
                    if (todate && moment(date).isAfter(moment(todate))) {
                      todate = null;
                    }
                    setFilters((prev) => ({
                      ...prev,
                      fromdate,
                      todate,
                    }));
                  }}
                  showIcon={true}
                />
              </div>
              <div className="filter-date-separator">TO</div>
              <div className="col-section category-section-container">
                <span className="filter-label">To Date</span>
                <DatePickerComponent
                  key={`to-${filters?.fromdate || 'empty'}-${
                    filters?.todate || 'empty'
                  }`}
                  value={filters?.todate ? new Date(filters.todate) : null}
                  placeholder="MM-DD-YYYY"
                  className="audit-date-picker"
                  minDate={
                    filters?.fromdate ? new Date(filters.fromdate) : null
                  }
                  onChange={(date) => {
                    if (!date) {
                      setFilters((prev) => ({ ...prev, todate: null }));
                      return;
                    }

                    const fromdate = filters?.fromdate;
                    if (fromdate && moment(date).isBefore(moment(fromdate))) {
                      //invalid selection
                      return;
                    }

                    const todate = moment(date).format('YYYY-MM-DD');

                    setFilters((prev) => ({ ...prev, todate }));
                  }}
                  showIcon={true}
                />
              </div>
            </div>
          </div>
          <div className="search-reset-group">
            <div className="col-section category-section-container search-button">
              <GenericButton
                id="reset-filter-button"
                variant="link"
                onClick={() => onSearch()}
                disabled={isLoading}
              >
                Search
              </GenericButton>
            </div>
            <div className="col-section">
              <div className="reset-filter-container">
                <span
                  onClick={() => {
                    setFilters({
                      userid: 'All',
                      actiontype: 'All',
                      usertype: 'All',
                      fromdate: null,
                      todate: null,
                    });
                    onSearch(true);
                  }}
                >
                  Reset Filter
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnumerationAuditLogFilter;
